import React from 'react'
import { InvoiceHeader } from './invoice/invoiceHeader'
import { useTranslation } from '@hooks/useTranslation'
import { useSelector } from 'react-redux'
import InvoiceDetail from './invoice/InvoiceDetail'
import MassUpdateDMS from './massUpdateDMS'
const InvoiceContainer = () => {
  const translate = useTranslation()
  const dataSource = useSelector((state) => state.invoiceReducer.invoice.invoiceUpperHeader)
  return (
    <div className='headerDetails formContentareaC88'>
      <InvoiceHeader translate={translate} dataSource={dataSource} />
      <MassUpdateDMS />
      <InvoiceDetail />
    </div>
  )
}

export default React.memo(InvoiceContainer)
